import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type ContactAddress } from "@/lib/types";
import { omit } from "lodash";
import { baseContactRoute } from "./contact";

export function createContactAddressV1(
  data: Pick<
    ContactAddress,
    "city" | "state" | "zipCode" | "label" | "country" | "contactId"
  > &
    Partial<ContactAddress>,
) {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<ContactAddress>>(`${baseContactRoute}/addresses`, data)
    .then((res) => res.data);
}

export function updateContactAddressV1(
  data: Pick<ContactAddress, "id" | "contactId" | "dateModified"> &
    Partial<ContactAddress>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<ContactAddress>
    >(`${baseContactRoute}/addresses`, omit(data, "contactId"))
    .then((res) => res.data);
}

export function deleteContactAddressV1({
  id,
}: {
  contactId: string;
  id: string;
}) {
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<ContactAddress>>(`${baseContactRoute}/addresses/${id}`)
    .then((res) => res.data);
}
